const CODE_BLOCK_TYPE = "code-block";
export {
  CODE_BLOCK_TYPE
};
//# sourceMappingURL=types.js.map
